import React, { useState, createRef } from "react";
import UserIcon from "../icons/user.png";
import ProfileContainer from "./ProfileContainer";

const ProfileModal = ({
  closeModalAfterUpload,
  currentUser,
  currentUserAvatar,
  errors,
  logout,
  posts,
  setCurrentUserAvatar,
  setErrors,
  setPosts,
}) => {
  const [avatarOrientation, setAvatarOrientation] = useState("");
  const [previewAvatar, setPreviewAvatar] = useState("");
  const [previewMessage, setPreviewMessage] = useState(true);
  const avatarRef = createRef();

  const avatarSize = (height, width) => {
    if (height > width) {
      setAvatarOrientation("portrait");
    } else {
      setAvatarOrientation("landscape");
    }
  };

  return (
    <div className="auth-modal">
      <div className="preview-panel">
        <div className="mobile-header">
          <button className="close-btn" onClick={closeModalAfterUpload}>
            X
          </button>
          <h2>Update your profile photo</h2>
        </div>
        <div className="static-container">
          <div className="profile-img-container">
            <img
              ref={avatarRef}
              onLoad={() => {
                avatarSize(
                  avatarRef.current.naturalHeight,
                  avatarRef.current.naturalWidth
                );
              }}
              src={
                previewAvatar !== ""
                  ? previewAvatar
                  : currentUserAvatar !== null
                  ? currentUserAvatar
                  : UserIcon
              }
              alt="user-icon"
              className={
                avatarOrientation === "portrait"
                  ? "portrait-img"
                  : "landscape-img"
              }
            />
          </div>
          <div className="desktop-username">
            <p className="username">{currentUser}</p>
          </div>
        </div>
        <div className="preview-container">
          {previewAvatar !== "" && previewMessage ? (
            <p className="preview">
              Image preview
              <br />
              Click upload to save!
            </p>
          ) : null}
        </div>
      </div>
      <div className="profile-form">
        <ProfileContainer
          closeModalAfterUpload={closeModalAfterUpload}
          currentUser={currentUser}
          errors={errors}
          logout={logout}
          posts={posts}
          previewAvatar={previewAvatar}
          previewMessage={previewMessage}
          setCurrentUserAvatar={setCurrentUserAvatar}
          setErrors={setErrors}
          setPosts={setPosts}
          setPreviewAvatar={setPreviewAvatar}
          setPreviewMessage={setPreviewMessage}
        />
      </div>
    </div>
  );
};

export default ProfileModal;
